module.exports = __webpack_public_path__ + "img/operationCapacity9.92ade050.png";